function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard"
}, /*#__PURE__*/React.createElement("g", {
  id: "Billing-Payment-History",
  transform: "translate(-127.000000, -221.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-29",
  transform: "translate(127.000000, 221.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(0.000000, 0.500000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 0.015877)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  d: "M9.3,15c-2.1,0-4.2,0-6.3,0c-1.1,0-2.3-0.7-2.8-1.9C0.1,12.7,0,12.3,0,12c0-2.1,0-4,0-4 c1.7,0,3.8,0,5.5,0C5.7,8,6,8,6.2,8C7.3,7.7,8,6.9,8,5.8C8,4.7,8,0.7,8,0c0,0,4.5,0,7.7,0c1.5,0,2.8,1.3,2.8,2.9 c0,3.1,0,6.1,0,9.2c0,1.8-1.6,2.9-3,2.9C13.4,15,9.3,15,9.3,15z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(3.054545, 3.070423)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-4_2_",
  d: "M12.4,12.9c1,0,1.9-0.2,2.7-0.9c0.8-0.7,1.2-1.6,1.3-2.6c0-0.2,0-9.4,0-9.4 c0.1,0.1,0.2,0.1,0.3,0.2c0.7,0.6,1.2,1.4,1.2,2.4c0,2.2,0,4.5,0,6.7c0,2.6-2.2,4.8-4.8,5c-0.2,0-0.5,0-0.7,0 c-3.2,0-6.3,0-9.5,0c-1,0-1.8-0.3-2.5-1c-0.1-0.1-0.3-0.4-0.5-0.5L12.4,12.9z"
}))))));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5,1.1V6C6.5,6.5,6,7,5.5,7H0.6L6.5,1.1z"
});

var SvgTemplate = function SvgTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 19",
    style: {
      enableBackground: "new 0 0 21 19"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/template.0386e6ea.svg";
export { ForwardRef as ReactComponent };